import { Link, Outlet, createRootRouteWithContext } from "@tanstack/react-router"
import type { ReactNode } from "react"

import type { AccessStore } from "../../access/access-store"

/**
 * Контекст маршрутизатора. Через него маршрут добирается до состояния доступа
 * в beforeLoad — то есть ДО отрисовки, вне дерева React. Это и есть механизм,
 * которым «проверяем доступ» не превращается в мигание «нет доступа».
 */
export interface RouterContext {
  readonly access: AccessStore
}

function NotFoundScreen(): ReactNode {
  return (
    <div style={{ padding: "40px 24px" }}>
      <h1 style={{ fontSize: "var(--font-size-lg)", margin: "0 0 8px" }}>Страница не найдена</h1>
      <p style={{ color: "var(--text-secondary)", margin: "0 0 16px" }}>
        Адрес не относится ни к одному разделу кабинета.
      </p>
      <Link to="/" style={{ color: "var(--text-brand)" }}>
        Вернуться в кабинет
      </Link>
    </div>
  )
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: NotFoundScreen,
})
